(function() {
  try {
    window.__OVE_MODE__ = __OVE_MODE__;
  } catch (e) {
    window.__OVE_MODE__ = window.__OVE_MODE__ || "development";
  }
  const params = new URLSearchParams(window.location.search);
  const hashStr = window.location.hash;
  if (hashStr.includes("?")) {
    const hashParams = new URLSearchParams(hashStr.split("?")[1]);
    hashParams.forEach((v, k) => params.set(k, v));
  }
  const hasSuppressReloadSet = localStorage.getItem("suppressReload") === "true";
  if (params.get("reload") === "false" || params.get("nohmr") === "true" || hasSuppressReloadSet) {
    console.warn("[OVE] HMR suppression active (via URL or localStorage)");
    const OriginalWebSocket = window.WebSocket;
    const mockWS = function(url, protocols) {
      const isViteHmr = typeof url === "string" && (url.includes("vite-hmr") || url.includes("hmr")) || Array.isArray(protocols) && protocols.includes("vite-hmr") || protocols === "vite-hmr";
      if (isViteHmr) {
        console.warn("[OVE] Blocking HMR WebSocket connection to:", url);
        return {
          close: () => {
          },
          send: () => {
          },
          addEventListener: () => {
          },
          removeEventListener: () => {
          },
          binaryType: "blob",
          bufferedAmount: 0,
          extensions: "",
          protocol: "",
          readyState: 3,
          // CLOSED
          url,
          onopen: null,
          onmessage: null,
          onerror: null,
          onclose: null
        };
      }
      return new OriginalWebSocket(url, protocols);
    };
    Object.assign(mockWS, OriginalWebSocket);
    mockWS.prototype = OriginalWebSocket.prototype;
    window.WebSocket = mockWS;
    const OriginalEventSource = window.EventSource;
    if (OriginalEventSource) {
      window.EventSource = function(url, settings) {
        if (typeof url === "string" && (url.includes("vite-hmr") || url.includes("hmr"))) {
          console.warn("[OVE] Blocking HMR EventSource connection to:", url);
          return {
            close: () => {
            },
            addEventListener: () => {
            },
            removeEventListener: () => {
            },
            readyState: 2,
            // CLOSED
            url,
            onopen: null,
            onmessage: null,
            onerror: null
          };
        }
        return new OriginalEventSource(url, settings);
      };
      Object.assign(window.EventSource, OriginalEventSource);
    }
  }
})();
window.process = window.process || {
  env: { NODE_ENV: window.__OVE_MODE__ || "development" },
  platform: "browser",
  version: "",
  nextTick: (fn) => setTimeout(fn, 0)
};
window.global = window;
const originalWarn = console.warn;
const originalError = console.error;
const shouldSuppressWarning = (message) => {
  if (typeof message !== "string") return false;
  return message.includes("findDOMNode is deprecated") || message.includes("childContextTypes API") || message.includes("contextTypes API") || message.includes("hide() was called on a destroyed instance") || message.includes("Support for defaultProps will be removed") || message.includes("Unable to find any drag handles") || message.includes("Invariant failed: Draggable") || message.includes("Found ReflexContainer with width=0") || message.includes("reflex-layout reflex-container") || message.includes("use-local-storage-state - Error getting stored value") || message.includes(
    "<rect> attribute height: A negative value is not valid"
  ) || message.includes("<rect> attribute width: A negative value is not valid") || message.includes(
    "Error: <rect> attribute height: A negative value is not valid"
  ) || message.includes(
    "Error: <rect> attribute width: A negative value is not valid"
  ) || message.includes("Blocked aria-hidden");
};
const sanitize = (arg) => {
  if (arg && typeof arg === "object") {
    try {
      if (arg instanceof Node) {
        return `[DOM Node: ${arg.nodeName}${arg.className ? "." + arg.className : ""}]`;
      }
      if (arg.constructor && (arg.constructor.name === "FiberNode" || arg.constructor.name === "ReactElement")) {
        return `[React ${arg.constructor.name}]`;
      }
    } catch (e) {
      return "[Unsafe Object]";
    }
  }
  return arg;
};
console.warn = function(...args) {
  const sanitizedArgs = args.map(sanitize);
  const allArgs = sanitizedArgs.join(" ");
  if (allArgs.includes(
    "Attempted to synchronously unmount a root while React was already rendering"
  )) {
    console.info("[INFO - Captured React Warning]:", ...sanitizedArgs);
    return;
  }
  if (shouldSuppressWarning(allArgs)) return;
  originalWarn.apply(console, sanitizedArgs);
};
console.error = function(...args) {
  const sanitizedArgs = args.map(sanitize);
  const allArgs = sanitizedArgs.join(" ");
  if (allArgs.includes(
    "Attempted to synchronously unmount a root while React was already rendering"
  )) {
    console.info("[INFO - Captured React Warning]:", ...sanitizedArgs);
    return;
  }
  if (shouldSuppressWarning(allArgs)) return;
  originalError.apply(console, sanitizedArgs);
};
if (typeof SVGElement !== "undefined") {
  const originalSetAttribute = SVGElement.prototype.setAttribute;
  SVGElement.prototype.setAttribute = function(name, value) {
    const dimensionAttrs = ["width", "height", "x", "y", "rx", "ry", "r"];
    if (dimensionAttrs.includes(name) && typeof value === "number" && value < 0) {
      originalSetAttribute.call(this, name, 0);
      return;
    }
    originalSetAttribute.call(this, name, value);
  };
}
